module.exports = __webpack_public_path__ + "static/media/YF71_4.43d43451.jpg";